import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import apiRequest from '../../lib/http'

const AccountSelector = () => {
  const [accounts, setAccounts] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchAccounts = async () => {
      try {
        const res = await apiRequest.get('/portal/linked-accounts')
        const data = res.data.data || res.data || []
        setAccounts(data)

        if (data.length === 1) {
          localStorage.setItem('portalAccountId', data[0]._id)
          navigate('/portal')
        }
      } catch (err) {
        console.error('Failed to fetch linked accounts:', err)
      } finally {
        setLoading(false)
      }
    }
    fetchAccounts()
  }, [])

  const handleSelect = (accountId) => {
    localStorage.setItem('portalAccountId', accountId)
    navigate('/portal')
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-text-secondary">Loading...</div>
      </div>
    )
  }

  if (accounts.length === 0) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="border border-divider bg-surface shadow-lg rounded-2xl p-12 text-center max-w-md">
          <div className="text-xl font-bold text-text-primary mb-2">No Linked Accounts</div>
          <p className="text-text-secondary">
            Your account is not linked to any active cases. Please contact your representative.
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="border border-divider bg-surface shadow-lg rounded-2xl p-12 max-w-md w-full">
        <h1 className="text-2xl font-bold text-text-primary mb-2">Select Account</h1>
        <p className="text-text-secondary mb-8">Choose which account you'd like to view.</p>
        <div className="space-y-3">
          {accounts.map((account) => (
            <button
              key={account._id}
              onClick={() => handleSelect(account._id)}
              className="w-full text-left p-4 rounded-xl border border-divider hover:border-primary-main hover:bg-[color-mix(in_srgb,var(--color-primary-main)_5%,transparent)] transition-colors"
            >
              <div className="font-semibold text-text-primary">
                {account.firstName} {account.lastName}
              </div>
              <div className="text-sm text-text-secondary">Debt Program</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AccountSelector
